export const enum MaxSqFtSalePriceEnum {
  None = 0,
  UpTo850 = 1,
  UpTo1000 = 2,
  UpTo1500 = 3,
  NoMax = 4,
}
